import { render, staticRenderFns } from "./MultipleFreezoneSlotSortable.vue?vue&type=template&id=f5c40364&scoped=true&"
import script from "./MultipleFreezoneSlotSortable.vue?vue&type=script&lang=ts&"
export * from "./MultipleFreezoneSlotSortable.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleFreezoneSlotSortable.vue?vue&type=style&index=0&id=f5c40364&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c40364",
  null
  
)

export default component.exports